module.exports = __webpack_public_path__ + "static/yellowlocalhost-85af81833756a69d28d389386fddf336.png";